export default (contest) => {
  return contest.categories.reduce((rounds, category) => {
    category.rounds.forEach((round) => {
      rounds.push({
        ...round,
        categoryName: category.name,
      });
    });
    return rounds;
  }, []);
};
